import React from "react";
import { useRouter } from "next/router";
import { isProspect } from "@/utils/type";

import SearchPage from "../../components/search/SearchPage";
import NotFound from "@/components/common/NotFound";

const Search = ({ type }) => {
    const router = useRouter();
    const { search } = router.query;

    return isProspect(type) ? <SearchPage search={search} /> : <NotFound />;
};

// can use getStaticProps without getStaticPath, so use getServerSideProps here
export async function getServerSideProps(context) {
    // get the search query from the URL
    let { search } = context.query;

    // replace the last "-" with ", ", and all other "-" with " "
    search = search.replace(/-([^-]*)$/, ", $1").replace(/-/g, " ");

    // search is "City, State"; extract just the city
    const city = search.split(",")[0].trim();
    const title = `Assisted Living Facilities, ${city} | Nursing Care Homes near ${search}`;

    return {
        props: {
            type: process.env.NEXT_PUBLIC_TYPE,
            meta: {
                title,
                description: "Search for " + search + " on Purple Door",
                ogTitle: title,
                ogImage:
                    "https://cdn.purpledoorfinders.com/purpledoorfinders/logo-for-meta-data.sm.webp",
                ogType: "website",
            },
        },
    };
}

export default Search;
